import {
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  inject,
  model,
  ModelSignal,
  QueryList,
} from '@angular/core';
import { SectionComponent } from '../../layout/section/section.component';
import { SubSectionComponent } from '../../layout/sub-section/sub-section.component';
import { CmsTextProviderService } from '../../../services/cms-text-provider.service';

type CollapsibleComponent = SectionComponent | SubSectionComponent;

@Component({
  selector: 'aw-unfold',
  imports: [],
  templateUrl: './unfold.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnfoldComponent {
  public readonly collapsed: ModelSignal<boolean> = model(false);
  protected readonly cmsTextProvider: CmsTextProviderService = inject(
    CmsTextProviderService
  );

  @ContentChildren(SectionComponent, { descendants: true })
  private readonly sections!: QueryList<SectionComponent>;

  @ContentChildren(SubSectionComponent, { descendants: true })
  private readonly subSections!: QueryList<SubSectionComponent>;

  protected get areAllItemsCollapsed(): boolean {
    const items: CollapsibleComponent[] = this.collapsibleItems;
    return items.length > 0
      ? items.every(item => item.isCollapsed)
      : this.collapsed();
  }

  protected toggleAll(): void {
    const shouldCollapse = !this.areAllItemsCollapsed;

    this.collapsibleItems.forEach((item: CollapsibleComponent): void => {
      if (item.isCollapsed !== shouldCollapse) {
        item.toggleCollapse();
      }
    });
    this.collapsed.set(shouldCollapse);
  }

  private get collapsibleItems(): CollapsibleComponent[] {
    return [
      ...(this.sections?.toArray() ?? []),
      ...(this.subSections?.toArray() ?? []),
    ].filter((item: CollapsibleComponent): boolean => item.isCollapsible());
  }
}
